import { Flex } from "@chakra-ui/react"
import { FhResponseData } from "../../../../../common/types/search"
import { LowerLevelCategoryTile } from "./LowerLevelCategoryTile/LowerLevelCategoryTile"
import { UpperLevelCategoryTile } from "./UpperLevelCategoryTile/UpperLevelCategoryTile"

type Props = {
  categories: FhResponseData
  handleCategorySelect: (_urlParams: string, categoryValue: string, isActive: boolean) => void
}

const CategoriesList = ({ categories, handleCategorySelect }: Props) => {
  const isLowerLevel = categories.every((cat: FhResponseData) => cat.is_leaf_category)

  return (
    <Flex
      gap="6"
      rowGap={isLowerLevel ? "4" : "6"}
      flexWrap="wrap"
      display={{ base: "none", md: "flex" }}
      id="category-wrapper"
    >
      {categories.map((category: FhResponseData) =>
        isLowerLevel ? (
          <LowerLevelCategoryTile
            category={category}
            handleCategorySelect={handleCategorySelect}
            key={category.value.value}
          />
        ) : (
          <UpperLevelCategoryTile
            category={category}
            handleCategorySelect={handleCategorySelect}
            key={category.value.value}
          />
        )
      )}
    </Flex>
  )
}

export default CategoriesList
